<template lang="html">
  <div class="ja">
      <!-- banner -->
      <div class="qyj-banner">
          <!-- <img width="100%" src="https://static.qyjmed.com/webSite/aboutUs/ja/ja-bg.png" alt=""> -->
      </div>
      <!-- 诞生 -->
      <div class="born">
          <div class="container">
              <div data-wow-delay="1s" class="wow bounceInLeft born-content">
                  <h2>极安的诞生</h2>
                  <p>江苏极安医疗设备有限公司成立于2016年，系江苏全医佳电子商务有限公司的控股子公司。江苏极安是一家提供医疗设备维修服务的高科技企业。 </p>
                  <p>拥有一支高素质的专业工程师队伍，技艺精湛，公司具备完善的标准化服务流程，24小时呼叫中心，多品种、数量巨大的维修配件，通过快速响应客户需求，及时维护, 定期的保养机制等服务来提高设备开机率，提高设备使用效率，延长设备的使用寿命，为用户提供细致、周到、及时的服务。</p>
                  <p>公司不仅整合国内外优质的维修配件资源，具备“质量、价格、速度”等优势，而且擅长提供富有针对性的医疗设备维修方案。愿与广大医院、第三方维修公司和个人开展广泛、健康合作，互利双赢、共同发展。</p>
              </div>
              <div class="born-img">
                  <img src="https://static.qyjmed.com/webSite/aboutUs/ja/ja.png" alt="">
                  <img data-wow-delay="1s" class="wow bounceInRight" src="https://static.qyjmed.com/webSite/aboutUs/qyj/born-img1.png" alt="">
              </div>
          </div>
      </div>
      <div class="centent">
          <img src="https://static.qyjmed.com/webSite/aboutUs/ja/ja-content.png" alt="">
      </div>
      <Foot></Foot>
  </div>
</template>

<script>
import Foot from '@/components/Footer.vue'
import {WOW} from 'wowjs';
export default {
  name: 'HeaderTop',
  mounted() {
      var wow=new WOW({
          live: false
      })
      wow.init()
  },
  components: {
      Foot
  }
}
</script>

<style lang="scss" scoped>
    .ja{
        .qyj-banner{
            margin-top: $highlight-height;
            background: url('https://static.qyjmed.com/webSite/aboutUs/ja/ja-bg.png') center;
            height: 562px;
        }
        // 诞生
        .born{
            background: #FAFAFA;
            .container{
                .born-content{
                    width: 650px;
                    display: inline-block;
                    vertical-align: top;
                    h2{
                        font-size: 34px;
                        font-weight: bold;
                        color: #262626;
                        margin: 188px 0 100px;
                    }
                    p{
                        font-size: 18px;
                        color:#333;
                        line-height: 36px;
                        text-indent: 2rem;
                        margin-bottom: 10px;
                    }
                }
                .born-img{
                    width: 550px;
                    display: inline-block;
                    img:first-child{
                        margin: 380px 0 116px 50px;
                        position: absolute;
                        z-index: 10;
                    }
                    img:last-child{
                        position: relative;
                        z-index: 9;
                        margin-left: 250px;
                    }

                }
            }
        }
        .centent{
            text-align: center;
            background: #FAFAFA;
            padding-bottom: 60px;
        }
    }
</style>
